import * as React from 'react';

import { ClassNameBuilder } from '../../utils/ClassNameBuilder';

import * as Styles from './Icon.module.scss';

interface Props extends React.HTMLAttributes<HTMLElement> {
  className?: string;
  color?: string;
  onClick?: (event: React.MouseEvent) => void;
  size?: string | number;
  src: string;
  title?: string;
  style?: React.CSSProperties;
  id?: string;
}

export const Icon: React.FC<Props> = React.memo((props) => {
  const { className = '', size, style: propStyle, src, color, title, onClick, id, ...rest } = props;
  const sizeStr = typeof props.size === 'string' ? size : `${size}px`;
  const classes = new ClassNameBuilder(Styles, 'icon', [className, !!className]).add([
    'click',
    !!onClick,
  ]);

  const style: React.CSSProperties = {
    ...propStyle,
    WebkitMaskImage: `url(${src})`,
  };
  if (size) {
    style.width = sizeStr;
    style.height = sizeStr;
  }
  if (color) {
    style.background = color;
  }

  return (
    <i
      id={id}
      title={title}
      className={classes.toString()}
      {...rest}
      style={style}
      onClick={onClick}
    ></i>
  );
});

Icon.displayName = 'Icon';
